import ServerSideDataTable from "../../../Feature/DataTable/ServerSideDataTable";
import ModalDatatableItem from "../../../Feature/Modal/ModalDatatableItem";
import AppLoading from "../../../Feature/AppLoading";
import PageDependencies from "../../../Feature/PageDependencies";
import TooltipTemplate from "../../../Layout/AppNav/TooltipTemplate";
        
const BatchDataTable = (props) => {
  const { 
    Fragment, 
    useState,
    guid,
    getData,
    tryCatchFinally,
    dataExtension,
    toastPrint,
    htmlToReactParse,
  } = PageDependencies();
  const [modal, setModal] = useState({
    isOpen: false,
    title: "",
    message: "",
    comfirmButtonStyle: "",
    comfirmButtonText: "Comfirm",
    handleComfirm: () => {},
  });
  const [loading, setLoading] = useState({isLoading:false,text:""});
  const [tableReload, setTableReload] = useState("");
  const postUrl = "api/AnalysisResult/Accessor/BatchProcessTerminate";

  function generateTime(model, cloumn, index, style, onColumnValueChangeEvent){
      const date = new Date(model[cloumn.name]);
      const formatted =
      date.toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
      }).replace(",", "");
      return formatted;
  }

  function generateDownloadUrl(model, cloumn, index, style, onColumnValueChangeEvent){
  const value = model.resultsFileUrl;
  if(value === undefined || value === null || value.length === 0){
    return "";
  }
  return <a href={value}>Download</a>;
 }

 function getLines(str) {
  return str.split(/\r?\n/).filter(line => line.trim() !== "");
}

 function generateProjectNames(model, cloumn, index, style, onColumnValueChangeEvent){
    const values = getLines(model[cloumn.name]);
    let content = "";
    for(let i = 0; i < values.length; i++){
      if(i !== values.length -1){
        content = content + values[i] + "<br>";
      }else{
        content = content + values[i];
      }
    }
    const html = htmlToReactParse(content);
    return html;
 }

  //development table
  const [data, setData] = useState([]);
  const tableId = "BatchDataTable_3be58d90-e946-4514-9300-45dcdb39157a";
  const columns = [
        { name: "projectNames", text: "Projects", width: "40%" , generate: generateProjectNames, disableSorting: true},
        { name: "startTime", text: "Start Time", width: "20%" , generate: generateTime},
        { name: "endTime", text: "End Time", width: "20%", generate: generateTime },
        { name: "status", text: "Status", width: "10%" },
        { name: "resultsFileUrl", text: "Download", width: "10%", generate: generateDownloadUrl, disableSorting: true },
  ];
  const contextMenu = {
    items: {
      terminate: {
        name: "Terminate",
        icon: "delete",
        url: "",
        defaultAction: false,
        disabled: function () {
          return dataExtension.getSelectedRowDataIds(data).length === 0;
        },
      },
    },
    callBack: (
      contextMenuCallBackKey,
      contextMenuCallBackElement,
      contextMenuCallBackTableRoadData,
      localtion
    ) => {
      if (contextMenuCallBackKey === "terminate") {
        setModal({
          ...modal,
          isOpen: true,
          title: "Terminate batch simulation",
          message:
            "Are you sure you want to terminate " +
            dataExtension.getSelectedRowDataIds(data).length +
            " selected batch simulations(s)?",
          comfirmButtonStyle: "danger",
          comfirmButtonText: "Confirm to terminate",
          handleComfirm: handleDeleteComfirm,
        });
      }
    },
  };

  const handleDeleteComfirm =() =>{
     tryCatchFinally.asyncProcess(async ()=>{
      const instanceIds = dataExtension.getSelectedRowDataIds(data);
      console.log(instanceIds);
      const postModel = {
          instanceIds: instanceIds
      };
    const response = await getData.processPost(true, postUrl, postModel);
    toastPrint.printResponse(response);
     }, setLoading, ()=>{
         setModal({...modal, isOpen: false,});
         setTableReload(guid.newGuid());
     });
  }

  return (
    <Fragment>
      <ModalDatatableItem
        modal={modal}
        setModal={setModal}
      ></ModalDatatableItem>
      <div id="BatchProcessStatusesAccordion">
        <div className="main-card mb-3 card">
          <div className="card-header">
            <button
              type="button"
              data-toggle="collapse"
              data-target="#BatchProcessStatusesCollapsibleDiv"
              aria-expanded="true"
              aria-controls="BatchProcessStatusesCollapsibleDiv"
              className="text-left m-0 p-0 btn btn-block"
            >
              <h5 className="m-0 p-0 card-title">Batch Process Statuses<TooltipTemplate text="This table lists groups of project(s) associated with the same development, such as apartments." result={0} color="grey" /></h5>
            </button>
          </div>
          <div
            data-parent="#BatchProcessStatusesAccordion"
            id="BatchProcessStatusesCollapsibleDiv"
            className="hide collapse show"
          >
            <div className="card-body">
              {loading.isLoading && <AppLoading active><div>{loading.text}</div></AppLoading>}           
              <ServerSideDataTable
                id={tableId}
                location="BatchDataTable"
                data={data}
                setData={setData}
                reload={tableReload}
                columns={columns}
                actionOnDoubleClickRow
                allowSelect
                allowSelectMultiple
                dataSource={{ isAuth: true, url: "api/AnalysisResult/Accessor/BatchProcessStatuses" }}
                contextMenu={contextMenu}
                setSelectedItemIds = {props.setSelectedItemIds}
              ></ServerSideDataTable>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default BatchDataTable;
